import { Card, CardContent, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core'
import React from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { choicesState, loadingState, predictionState, whenAnsweredState } from '../atoms'
import { predict } from '../utils'


const WordItem = props => {
    const [choices, setChoices] = useRecoilState(choicesState)
    const [predictions, setPredictions] = useRecoilState(predictionState)
    const [whenAnswered, setWhenAnswered] = useRecoilState(whenAnsweredState)
    const setLoading = useSetRecoilState(loadingState)
    const handleChange = async event => {
        setLoading(true)
        let wordDefinitionsChoices = [...choices.wordDefinitions]
        if (wordDefinitionsChoices[props.id] === -1) {
            let whenAnsweredWordDefinitionsPredictions = [...whenAnswered.wordDefinitions]
            whenAnsweredWordDefinitionsPredictions[props.id] = predictions.wordDefinitions[props.id]
            setWhenAnswered({
                activities: whenAnswered.activities,
                tenPersonalItemInventory: whenAnswered.tenPersonalItemInventory,
                wordDefinitions: whenAnsweredWordDefinitionsPredictions
            })
        }
        wordDefinitionsChoices[props.id] = Number(event.target.value)
        setChoices({
            activities: choices.activities,
            tenPersonalItemInventory: choices.tenPersonalItemInventory,
            wordDefinitions: wordDefinitionsChoices
        })
        const [activitiesPrediction, tenPersonalItemInventoryPrediction, wordDefinitionsPrediction] = await predict(choices.activities, choices.tenPersonalItemInventory, wordDefinitionsChoices)
        setPredictions({
            activities: activitiesPrediction,
            tenPersonalItemInventory: tenPersonalItemInventoryPrediction,
            wordDefinitions: wordDefinitionsPrediction
        })
        setLoading(false)
    }
    const predictionText = () => {
        let prediction = predictions.wordDefinitions[props.id]
        if (whenAnswered.wordDefinitions[props.id] !== -1)
            prediction = whenAnswered.wordDefinitions[props.id]
        let text = String(prediction)
        switch (Math.round(prediction)) {
            case 0:
                text += " (Don't know)"
                break;
            case 1:
                text += " (Know)"
                break;
            default:
                break;
        }
        return text
    }
    return (
        <Card variant='elevation' style={{ marginTop: '20px' }}>
            <CardContent>
                <Typography>
                    {props.id + 1} - {props.question}
                </Typography>
                <Grid container>
                    <Grid xs={6} item>
                        <FormControl component='fieldset'>
                            <RadioGroup value={String(choices.wordDefinitions[props.id])} onChange={handleChange}>
                                <FormControlLabel value="-1" control={<Radio />} label="Unselected" />
                                <FormControlLabel value="0" control={<Radio />} label="0- Don't know" />
                                <FormControlLabel value="1" control={<Radio />} label="1- Know" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid xs={6} item style={{ textAlign: 'center', alignSelf: 'center' }}>
                        <Typography style={{ color: 'red', fontStyle: 'italic' }}>
                            Predicted: {predictionText()}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default WordItem